/**
 * DG Custom - Member Pricing Variant Handler
 * Updates member pricing input when variant changes
 * FIXED: Now handles cases where variants don't have member pricing
 */

function initializeMemberPricing(container) {
  const variantPicker = container.querySelector('variant-picker');
  const variantMemberPricingDataElement = container.querySelector('[data-club-member-pricing-variants]');
  const memberPriceDisplayElement = container.querySelector('[data-dg-member-price-display]');
  const memberPriceFormInput = container.querySelector('input[name="properties[_club_member_price]"]');

  if (!variantPicker || !variantMemberPricingDataElement) {
    return;
  }

  const variantMemberPricingData = JSON.parse(variantMemberPricingDataElement.textContent);

  variantPicker.addEventListener('on:variant:change', (event) => {
    const selectedVariant = event.detail.variant;
    const selectedVariantMemberPricing = variantMemberPricingData.variants.find(
      (variant) => variant.id === selectedVariant.id
    );
    
    // Check if the variant has member pricing
    if (!selectedVariantMemberPricing || !selectedVariantMemberPricing.club_member_price || selectedVariantMemberPricing.club_member_price.value === null) {
      return;
    }
    
    // Update the display element
    if (memberPriceDisplayElement) {
      memberPriceDisplayElement.textContent = selectedVariantMemberPricing.club_member_price.asMoney;
    }
    
    // Update the member price form input
    if (memberPriceFormInput) {
      memberPriceFormInput.value = selectedVariantMemberPricing.club_member_price.value;
    }
  });
}

function handleDocumentClick(event) {
  if (event.target.matches('.js-quick-add')) {
    const quickAddDrawer = document.querySelector('quick-add-drawer');
    if (quickAddDrawer) {
      setTimeout(() => {
        const isOpen = quickAddDrawer.hasAttribute('open');
        if (isOpen) {
          initializeMemberPricing(quickAddDrawer);
        }
      }, 200);
    }
  }
}

function init() {
  document.addEventListener('click', handleDocumentClick.bind(this));
  const productMain = document.querySelector('.product-main');
  if (productMain) {
    initializeMemberPricing(productMain);
  }
}

init();
